import { combineReducers } from 'redux-immutable';
import searchReducer from "../../common/reducer/Search";
import discoverReducer from "./Discover";
const store = combineReducers({
  discover: discoverReducer,
  search: searchReducer
});
export default store;